import React from "react";

export const Modal = props =>
  <div id={props.modalid ? props.modalid : "modal"} class="modal">
    <div class="modal-dialog-wrapper">
      <div class="modal-dialog">
        <div class="modal-box">
          <div class="modal-header">
            <h3>{props.title}</h3>
          </div>
          <div class="modal-body">
            <p>{props.description}</p>
            {props.link ? props.link : null}
            {props.confirmInput ? props.confirmInput : null}
          </div>

          <div class="modal-footer">
            {props.cancelLabel ? <a class="btn btn-faded" data-toggle="dismiss-modal">{props.cancelLabel}</a> : null}
            {props.confirmLabel && props.onClick ? <button class="btn btn-main" data-toggle="dismiss-modal" onClick={props.onClick} id={props.id}>{props.confirmLabel}</button> : null}
          </div>
        </div>
      </div>
    </div>
  </div>
